// extracted by css-extract-rspack-plugin
export default {"appStoreIcon":"_2f62017b"};